export default __webpack_public_path__ + "static/media/next_section_hover.394ca8f0.svg";